var installedModules = {};
var moduleToHandlerMapping = {
	0: {
		getter: () => (() => (__webpack_require__(1449))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	20: {
		getter: () => (() => (__webpack_require__(2670))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	3750: {
		getter: () => (() => (__webpack_require__(1051))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	3944: {
		getter: () => (() => (__webpack_require__(2675))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	4097: {
		getter: () => (() => (__webpack_require__(2655))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.20.40",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "glamor",
	},
	4099: {
		getter: () => (() => (__webpack_require__(2671))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	4111: {
		getter: () => (() => (__webpack_require__(2672))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "3.0.5",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	},
	4129: {
		getter: () => (() => (__webpack_require__(2656))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "launchdarkly-react-client-sdk",
	},
	4493: {
		getter: () => (() => (__webpack_require__(2657))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "npm:react-dnd@^11.1.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dnd-latest",
	}
};
var initialConsumes = [0];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"2": [
		0
	],
	"3": [
		20,
		3750,
		3944,
		4097,
		4099,
		4111,
		4129,
		4493
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}